export class AiModel {
  name: string;
  code: string;

  static readonly gemini2Flash = new AiModel(
    "Google Gemini 2.0 Flash",
    "google/gemini-2.0-flash-001"
  );

  static readonly gpt4o = new AiModel(
    "OpenAI GPT-4o",
    "openai/gpt-4o-2024-08-06"
  );

  static readonly gpt4oMini = new AiModel(
    "OpenAI GPT-4o Mini",
    "openai/gpt-4o-mini-2024-07-18"
  );

  static readonly o3Mini = new AiModel("OpenAI o3 Mini", "openai/o3-mini");

  static readonly deepseekR1 = new AiModel(
    "DeepSeek R1",
    "deepseek/deepseek-r1"
  );

  static readonly gemini2FlashPreview = new AiModel(
    "Google Gemini 2.5 Flash Preview",
    "google/gemini-2.5-flash-preview-09-2025"
  );

  static readonly free = [AiModel.gemini2Flash];

  static readonly paid = [
    AiModel.gemini2Flash,
    AiModel.gpt4o,
    AiModel.gpt4oMini,
    AiModel.o3Mini,
    AiModel.deepseekR1,
    AiModel.gemini2FlashPreview,
  ];

  static readonly all = [...AiModel.free, ...AiModel.paid];

  constructor(name: string, code: string) {
    this.name = name;
    this.code = code;
  }
}
